function validateResponse(response) {
    if (!response.ok) {
        if (response.status === 401) {
            window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/mvc/auth/login";
            return null;
        } else {
            throw new Error("Unknown error occurred : " + response.statusText);
        }
    }
}

export function getAppCatalog(getUserCallback) {
    console.log('in getAppCatalog');
    fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/api/appCatalog', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            method: 'GET'
    })
    .then(response => {
        validateResponse(response);
        return response.json();
    })
    .then(json => {
        console.log('App catalog data ', json);
        getUserCallback(json);
        return json;
    })
    .catch(error => {
        console.log("Error geting App Catalog from server: " + error.message);
        window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/errorRedirect.jsp?errorKey=request.processing.error";
        return Promise.reject();
    });
}



// WEBPACK FOOTER //
// ./src/manageMyAccount/GetAppCatalog.js